import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import OpeningHours from './openingHours';

class OpeningHoursPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mallUniqueHours: [],
    };
  }

  async onSubmit(e) {
    await this.child.onSubmit(e);
  }

  render() {
    return (
      <div>
        <div className="col-md-12">
          <OpeningHours
            childRef={(ref) => (this.child = ref)}
            match={this.props.match}
            params={this.props.match.params}
            id={this.props.match.params.id}
            setUniqueOpenHours={(e) => { this.setState({ mallUniqueHours: e }); }}
            isUsingAction
          />
        </div>
        <Button onClick={(e) => this.onSubmit(e)} type="submit" variant="contained" color="primary" style={{ width: '50%', marginTop: '30px' }}>
          Save
        </Button>
      </div>
    );
  }
}

export default OpeningHoursPage;
